/**
 * Created by Mark on 23/11/2016.
 */


import AppDispatcher from '../dispatcher/applciation.dispatcher.js';
import AuthenticationConstants from '../constants/authnetication.js';

let authenticationTimer = null;
let count = 0;
export default{

    Lock()
    {
        AppDispatcher.dispatch({actionType: "LOGOUT_WARNING", warning: true });
    },

    LockCount(){
        count++;

        if(count >= 25) return this.Lock();
        else
        {
            clearTimeout(sessionStorage.getItem(AuthenticationConstants.LOCKOUT_TIMER_ID));
            let token = setTimeout(this.LockCount , 60000);
            sessionStorage.setItem(AuthenticationConstants.LOCKOUT_TIMER_ID , token);
        }
    },

    resetAndSetLockTimer(apiToken){
        count =0;
        clearTimeout(sessionStorage.getItem(AuthenticationConstants.LOCKOUT_TIMER_ID));
        let token = setTimeout(this.LockCount.bind(this) , 60000);
        sessionStorage.setItem(AuthenticationConstants.LOCKOUT_TIMER_ID , token);
    },

    authenticateUser(apiToken)
    {

        sessionStorage.setItem('token', apiToken);
        this.resetAndSetLockTimer(apiToken);
        AppDispatcher.dispatch({actionType: AuthenticationConstants.LOGIN_USER, apiToken: apiToken });
    },

    unAuthenticateUser()
    {
        clearTimeout(localStorage.getItem(AuthenticationConstants.LOCKOUT_TIMER_ID));
        sessionStorage.removeItem('token');
        AppDispatcher.dispatch({actionType: AuthenticationConstants.LOGOUT_USER});
    },

    grantPermissions(permission)
    {
        AppDispatcher.dispatch({permission:permission ,  actionType:AuthenticationConstants.GRANT_PERMISSION});
    },

    getUserData(response){
        AppDispatcher.dispatch({response:response ,  actionType:AuthenticationConstants.GET_USER_DATA});
    }

}


// WEBPACK FOOTER //
// ./src/actions/authentication.actions.js